import { buildQuery } from '../lib/helper';
import client from '../lib/http-client';

const endpoint = '/api/events';

export default {
	/*
		Get list
	*/
	getList(params, cb, errorCb) {
		// const url = `/product/?limit=${params.limit}&sort_by=${params.sort_by}&sort=${params.sort}&page=${params.page}`;
		const query = buildQuery(params);
		const url = `${endpoint}?${query}`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Get list events template
	*/
	getTemplates(params, cb, errorCb) {
		const url = `${endpoint}/templates`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Get upcoming
	*/
	getUpcoming(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/upcoming?${query}`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Get upcoming dates
	*/
	getUpcomingDates(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/upcoming-dates?${query}`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Get statistics
	*/
	getStatistics(cb, errorCb) {
		const url = `${endpoint}/statistics`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Get details by slug
	*/
	getDetailsBySlug(slug, params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/${slug}?${query}`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Create
	*/
	create(params, cb, errorCb) {
		const url = endpoint;
		client.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Update
	*/
	update(id, params, cb, errorCb) {
		const url = `${endpoint}/${id}`;
		client.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Update Playback
	*/
	updatePlayback(id, params, cb, errorCb) {
		const url = `${endpoint}/${id}/playback`;
		client.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Change agenda status
	*/
	changeStatus(id, params, cb, errorCb) {
		const url = `${endpoint}/${id}/status`;
		client.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Bulk delete
	*/
	bulkDelete(ids, cb, errorCb) {
		const params = {
			event_ids: JSON.stringify(ids),
			is_deleted: 1,
		};
		const url = `${endpoint}`;
		const responseHandler = (response) => {
			if (cb) {
				cb(response.data);
			}
		};
		const errorHandler = (e) => {
			if (errorCb) {
				errorCb(e);
			}
		};
		client.delete(url, { data: params })
			.then(responseHandler)
			.catch(errorHandler);
	},

	/*
		Copy settings to all agenda
	*/
	copySettings(params, cb, errorCb) {
		const url = `${endpoint}/settings/copy`;
		client.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Copy
	*/
	copy(params, cb, errorCb) {
		const url = `${endpoint}/copy`;
		client.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	/*
		Delete permanent
	*/
	deletePermanent(id, cb, errorCb) {
		const params = {
			event_id: id,
		};
		const url = `${endpoint}/permanently`;
		const responseHandler = (response) => {
			if (cb) cb(response.data);
		};
		const errorHandler = (e) => {
			if (errorCb) errorCb(e);
		};
		client.delete(url, { data: params })
			.then(responseHandler)
			.catch(errorHandler);
	},

	/*
		Update
	*/
	copyDisplay(id, params, cb, errorCb) {
		const url = `${endpoint}/${id}/copy_display`;
		client.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},
};
